import React, { Component, useEffect, useState, useLayoutEffect } from 'react'
import Header from '../components/home/Header';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import NoticiasApi from 'services/robinhood/NoticiasApi';
import Meses from '../services/Meses';
import ListarNoticias from 'components/ListarNoticias';
import FaqsApi from 'services/robinhood/FaqsApi';
import ContentBox from 'components/ContentBox';
import ParceirosApi from 'services/robinhood/ParceirosApi';
import ListaParceiros from 'components/parceiros/ListaParceiros';

export default function Pesquisas(props) {

    const location = useLocation();
    const [publicacao, setPublicacao] = useState({});
    const [publicacoes, setPublicacoes] = useState([]);
    const [publicacoesExists, setPublicacoesExists] = useState(false);
    const [faqs, setFaqs] = useState([]);
    const [faqsExists, setFaqsExists] = useState(false);
    const [parceiros, setParceiros] = useState([]);
    const [parceirosExists, setParceirosExists] = useState(false);
    const cores = ['b-success', 'b-primary', 'b-secondary', 'b-warning', 'b-danger', ' b-greensea', 'b-lightred'];
    const [meses, setMes] = useState(Meses);

    let pesquisa = null;

    useEffect(() => {
        document.getElementById('toggle-menu').className = 'theme-blush ls-toggle-menu';
    }, []);

    useEffect(() => {
        pesquisa = location.state ? location.state.pesquisa : null;
        if (pesquisa && typeof (pesquisa) != 'undefined') {
            console.log('pesquisa', pesquisa);
            new NoticiasApi().pesquisar(pesquisa.trim()).then(response => {
                setPublicacoes(response);
                setPublicacoesExists(response && response.length > 0 && response[0].id != null ? true : false);
            });
            new FaqsApi().pesquisar(pesquisa.trim()).then(response => {
                setFaqs(response);
                setFaqsExists(response && response.length > 0 && response[0].id != null ? true : false);
            });
            new ParceirosApi().pesquisar(pesquisa.trim()).then(response => {
                setParceiros(response);
                setParceirosExists(response && response.length > 0 && response[0].id != null ? true : false);
            });

            scrollWindow();
        }
    }, [location.state]);

    const handlePublicacao = (_publicacao) => {
        setPublicacao(_publicacao);
    }
    const topFunction = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const handleScrool = (_element) => {
        const element = document.getElementById(_element);
        let elementPosition = null;
        if (element) {
            elementPosition = element.getBoundingClientRect().top;
            window.scrollTo({
                top: elementPosition + window.scrollX - 80,
                behavior: 'smooth',
            });
        }
    }

    const scrollWindow = () => {
        let mybutton = document.getElementById("buttomScrollUp");
        window.onscroll = function () { scrollFunction() };
        function scrollFunction() {
            if (document.documentElement.scrollTop > 60) {
                mybutton.style.display = "block";
            } else {
                mybutton.style.display = "none";
            }
        }
    }

    const CollapseComponent = () => {
        const collapse = [];
        collapse.push(
            faqs.map((faq) => {
                return (
                    <div className="panel-group" id={`accordion_${faq.id}`} role="tablist" aria-multiselectable="true" key={Math.random()}>
                        <div className="panel panel-col-blue-grey">
                            <div className="panel-heading" role="tab" id={`headingOne_${faq.id}`}>
                                <h4 className="panel-title rounded"><a role="button" data-toggle="collapse" data-parent={`#accordion_${faq.id}`} href={`#collapseOne_${faq.id}`} aria-expanded="true" aria-controls={`collapseOne_${faq.id}`}> {faq.faq}<i className='zmdi right zmdi-caret-down '></i> </a></h4>
                            </div>
                            <div id={`collapseOne_${faq.id}`} className="panel-collapse collapse in" role="tabpanel" aria-labelledby={`headingOne_${faq.id}`}>
                                <div className="anel-body" dangerouslySetInnerHTML={{ __html: faq.resposta }}></div>
                            </div>
                        </div>
                    </div>
                );
            })
        );
        return collapse;
    };

    return (
        <>
            <Header>
                <h5 style={{ marginLeft: '10px', marginBottom: '20px' }}> <i className='zmdi zmdi-search'></i> RESULTADO DE PESQUISA </h5>
                {!publicacoesExists && !faqsExists && !parceirosExists ?
                    <div className="col-lg-4 col-sm-6 col-md-6 col-xs-12 p-1">
                        <div className="card" style={{ backgroundColor: '#7F99A6' }}>
                            <a className='small text-white' style={{ textDecoration: 'none', color: 'white' }}>
                                <div className="body">
                                    <h4 style={{ textTransform: 'uppercase', color: 'white', paddingBottom: '0px', marginBottom: '0px' }}>  <i className='zmdi zmdi-alert-triangle ' style={{ fontSize: '30px' }}></i> OPS!   </h4>
                                    <span style={{ color: 'white' }} className=''> TENTE NOVAMENTE </span>
                                </div>
                            </a>
                        </div>
                    </div>
                    :
                    <div className='container-fluid'>
                        <div className='row'>
                            {publicacoesExists
                                ? <div className="col-lg-4 col-sm-6 col-md-6 col-xs-12 p-1">
                                    <div className="card bg-blue-grey">
                                        <a onClick={() => handleScrool('publicacoesHeader')} className='small text-white' style={{ textDecoration: 'none', color: 'white', cursor: 'pointer' }}>
                                            <div className="body">
                                                <h4 style={{ textTransform: 'uppercase', color: 'white', paddingBottom: '0px', marginBottom: '0px' }}>  <i className='zmdi zmdi-reader' style={{ fontSize: '30px' }}></i>  PUBLICAÇÕES </h4>
                                                <span style={{ color: 'white' }} className=''> {publicacoes ? publicacoes.length : 0} ÍTENS ENCONTRADOS </span>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                : null
                            }
                            {faqsExists ?
                                <div className="col-lg-4 col-sm-6 col-md-6 col-xs-12 p-1">
                                    <div className="card bg-blue-grey">
                                        <a onClick={() => handleScrool('faqsHeader')} className='small text-white' style={{ textDecoration: 'none', color: 'white', cursor: 'pointer' }}>
                                            <div className="body">
                                                <h4 style={{ textTransform: 'uppercase', color: 'white', paddingBottom: '0px', marginBottom: '0px' }}>  <i className='zmdi zmdi-help-outline' style={{ fontSize: '30px' }}></i>  FAQs </h4>
                                                <span style={{ color: 'white' }} className=''> {faqs.length} ÍTENS ENCONTRADOS </span>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                : null
                            }
                            {parceirosExists ?
                                <div className="col-lg-4 col-sm-6 col-md-6 col-xs-12 p-1">
                                    <div className="card bg-blue-grey">
                                        <a onClick={() => handleScrool('parceirosHeader')} className='small text-white' style={{ textDecoration: 'none', color: 'white', cursor: 'pointer' }}>
                                            <div className="body">
                                                <h4 style={{ textTransform: 'uppercase', color: 'white', paddingBottom: '0px', marginBottom: '0px' }}>  <i className='zmdi zmdi-accounts' style={{ fontSize: '30px' }}></i>  PARCEIROS </h4>
                                                <span style={{ color: 'white' }} className=''> {parceiros.length} ÍTENS ENCONTRADOS </span>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                : null
                            }
                        </div>
                    </div>

                }
            </Header>
            {!publicacoesExists && !faqsExists && !parceirosExists
                ? <h6 className='m-l-20 text-muted' style={{ marginTop: '-20px' }}><i class="zmdi zmdi-info"></i>  NÃO FORAM ENCONTRADOS DADOS REFERENTES A PESQUISA REALIZADA</h6>
                : null
            }

            {publicacoesExists
                ?
                <ListarNoticias publicacoes={publicacoes} handlePublicacao={handlePublicacao}>
                    <h6 id='publicacoesHeader'> PUBLICAÇÕES </h6>
                </ListarNoticias>
                : null
            }

            {faqsExists
                ? <div style={{ marginTop: '-60px' }}>
                    <ContentBox>
                        <h6 id='faqsHeader'> FAQs </h6>
                        <hr />
                        {faqsExists
                            ? <CollapseComponent></CollapseComponent>
                            : null
                        }
                    </ContentBox>
                </div>
                : null
            }


            {parceirosExists
                ? <>
                    <div style={{ marginTop: '-60px' }}>
                        <ContentBox>
                            <ListaParceiros parceiros={parceiros}>
                                <h6 id='parceirosHeader'> PARCEIROS </h6>
                                <hr />
                            </ListaParceiros>
                        </ContentBox>
                    </div>
                </>
                : null
            }

            <div class="modal fade" id="largeModalPublicacao" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h6 class="modal-title" style={{ textTransform: 'uppercase' }} id="largeModalLabel">{publicacao.titulo}</h6>
                        </div>

                        <div class="modal-body">
                            <p className='bold'><i className='zmdi zmdi-calendar'></i> {publicacao.data_publicacao && publicacao.data_publicacao.split('-').reverse().join('/')} </p>
                            <div className="content" dangerouslySetInnerHTML={{ __html: publicacao.noticia }}></div>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-link waves-effect btn-light" data-dismiss="modal"> FECHAR</button>
                        </div>
                    </div>
                </div>
            </div>
            <a onClick={topFunction} id="buttomScrollUp" className='btn btn-rouded  waves-effect'>
                <i className='zmdi zmdi-caret-up-circle' style={{ marginTop: '0px', paddingTop: '-10px' }}></i>
            </a>
            <div className='row' style={{ marginBottom: '100px' }}></div>
        </>
    )
}